import React from 'react'

const Contact = () => {
    return (
        <>


            <div>
                <section className="inner-banner">
                    <h1 className="fw-bold text-center">Contact Us</h1>
                </section>
                <section className="contact-section">
                    <div className="container">
                        <div className="sec-title text-center mb-3" data-aos="fade-up" data-aos-duration={1000}>
                            <span className="title">Contact Us</span>
                            <h2>We’d Love to Hear From You</h2>
                            <div className="divider">
                                <span className="fa fa-mortar-board" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-md-8">
                                <div className="contact-form p-5" data-aos="zoom-in" data-aos-duration={1000}>
                                    <div className="border-line" />
                                    {/* <h3 className="fw-bold color-orange">Drop Message</h3> */}

                                    {/* <img src="assets/images/contact.jpg" className="img-fluid rounded " alt="About" /> */}



                                    <form>
                                        <div className="mb-3">
                                            <label htmlFor="exampleInputName">Name</label>
                                            <input className="form-control" id="exampleInputName" placeholder="Enter Name" type="text" />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="exampleInputEmail1">Email Address</label>
                                            <input className="form-control" id="exampleInputEmail1" placeholder="Enter Email" type="email" />
                                            <small className="form-text text-muted" id="emailHelp">We'll never share your email with anyone
                                                else.
                                            </small>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="exampleInputNumber">Phone Number</label>
                                            <input className="form-control" id="exampleInputNumber" placeholder="Enter Number" type="email" />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="exampleInputMessage">Message</label>
                                            <input className="form-control" id="exampleInputMessage" placeholder="Message" type="email" />
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" id="exampleCheck1" type="checkbox" />
                                            <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                                        </div>
                                        <button className="btn theme-orange border-0 mt-4" type="submit">Send Message</button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 ms-minus">
                                <div className="media p-3 d-flex justify-content-between align-items-center theme-blue mb-3" data-aos="zoom-in" data-aos-duration={1000}>
                                    <div className="media-body text-start">
                                        <h6 className="color-orange fw-bold mb-1">Address</h6>
                                        <p className="mb-0">Mr Ahmed Al Wasl,
                                            PO Box 12345 Dubai UAE</p>
                                    </div>
                                    <img className="img-fluid contact-icon" data-aos="zoom-in" data-aos-duration={1050} src="assets/images/icons/location.png" alt="Location" />
                                </div>
                                <div className="media p-3 d-flex justify-content-between align-items-center theme-blue mb-3" data-aos="zoom-in" data-aos-duration={1000}>
                                    <div className="media-body text-start">
                                        <h6 className="color-orange fw-bold mb-1">Email</h6>
                                        <a
                                            href="mailto:  info@globalenglishacademy.org"
                                            class="mail"
                                        >
                                            info@globalenglishacademy.org
                                        </a>
                                    </div>
                                    <img className="img-fluid contact-icon" data-aos="zoom-in" data-aos-duration={1500} src="assets/images/icons/mail.png" alt="Mail" />
                                </div>
                                <div className="media p-3 d-flex justify-content-between align-items-center theme-blue" data-aos="zoom-in" data-aos-duration={1000}>
                                    <div className="media-body text-start">
                                        <h6 className="color-orange fw-bold mb-1">Contact Number</h6>
                                        <a href="tel: +971 521356139">
                                        +971 521356139
                                        </a>
                                    </div>
                                    <img className="img-fluid contact-icon" data-aos="zoom-in" data-aos-duration={1050} src="assets/images/icons/call.png" alt="Call" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default Contact